import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useDeleteDialog from './useDeleteDialog';
import { Trans } from "@lingui/react/macro"


const DeleteDialog = () => {
  const { open, onConfirm } = useSelector((state: {'deleteDialog': any}) => state.deleteDialog);
  const { closeDialog } = useDeleteDialog();

  return (
    <div>
      <Dialog open={open} onClose={() => closeDialog()}>
        <DialogTitle><Trans>Confirm Delete</Trans></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>Please confirm delete of the entity.</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button data-testid="delete-dialog-cancel-button" onClick={() => closeDialog()}><Trans>Cancel</Trans></Button>
          {/* Confirming has to close the dialog as well as run the callback.
              Leaving it open left the delete happening behind a dialog that
              never went away, and an open dialog is a modal: it takes the
              rest of the page out of the accessibility tree while it is
              there. */}
          <Button
            data-testid="delete-dialog-confirm-button"
            onClick={() => {
              closeDialog();
              onConfirm('delete');
            }}
          ><Trans>Confirm</Trans></Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteDialog;
